import { render } from "./CheckDetails.vue?vue&type=template&id=4c909703&scoped=true"
import script from "./CheckDetails.vue?vue&type=script&lang=js"
export * from "./CheckDetails.vue?vue&type=script&lang=js"

import "./CheckDetails.vue?vue&type=style&index=0&id=4c909703&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c909703"]])

export default __exports__